import { useRouter } from "next/router"

// ---------------------------------------------------------

import Layout from "../../layout"
import RenderBlocks from "@lib/renderBlocks"

import MarketoForm from "@components/marketoForm"
import RecommendedReading from "@components/recommended-reading"

// ---------------------------------------------------------

import { demo_page, form_container, row_container, content_container } from "./styles.module.scss"

// ---------------------------------------------------------

const DemoTemplate = ({ data, preview, recommended }) => {
  const router = useRouter()

  const { title, excerpt, featuredImage, form, modulesCollection } = data

  if (form) {
    form["slug"] = data.slug
    form["resourceType"] = "demo"
  }

  return (
    <Layout
      className={demo_page}
      pageTitle={title}
      excerpt={excerpt}
      preview={preview}
      featuredImage={featuredImage}
      navSettings={{
        hideNavLeft: false || router.query._hn,
        hideNavRight: true
      }}
    >
      <div className={row_container}>
        <div className={content_container}>
          {modulesCollection?.items && RenderBlocks(modulesCollection?.items)}
        </div>
        <div className={form_container}>
          <MarketoForm {...form} />
        </div>
      </div>
      <RecommendedReading recommended={recommended} />
    </Layout>
  )
}

export default DemoTemplate
